import { render, staticRenderFns } from "./configureProfile.vue?vue&type=template&id=a36218f8&scoped=true"
import script from "./configureProfile.vue?vue&type=script&lang=js"
export * from "./configureProfile.vue?vue&type=script&lang=js"
import style0 from "./configureProfile.vue?vue&type=style&index=0&id=a36218f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36218f8",
  null
  
)

export default component.exports